import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Breadcrumb } from "sprint-common-web";

import { adminSystemPlatformsRoute, adminAirlinesRoute, adminRoutes } from "../../AdminRoutes";
import { SystemPlatformDetailsContext } from "./context/SystemPlatformDetailsContext";

export const SystemPlatformDetailsBreadcrumb: React.VFC = () => {
    const history = useHistory();
    const { systemPlatformDetailsItem, isLoading } = useContext(SystemPlatformDetailsContext);

    const goToAirlinesListing = () => {
        history.push(adminAirlinesRoute.path);
    };

    const goToAirlineDetailsListing = () => {
        history.push(adminSystemPlatformsRoute.path.replace(":airlineId", systemPlatformDetailsItem.airline.id));
    };

    return (
        <Breadcrumb
            items={[
                ...adminRoutes.baseRouteNames.map((name: string) => {
                    return { key: name, text: name };
                }),
                {
                    key: "airlines",
                    text: "Airlines",
                    onClick: goToAirlinesListing
                },
                {
                    key: "airlineName",
                    text: systemPlatformDetailsItem.airline.name,
                    onClick: goToAirlineDetailsListing
                },
                {
                    key: "systemPlatformName",
                    text: systemPlatformDetailsItem.system.name
                }
            ]}
            isLoading={isLoading}
        />
    );
};
